import './i18n/index';
import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Boutique from './pages/Boutique';
import Orders from './pages/Orders';
import Contact from './pages/Contact';
import Emploi from './pages/Emploi';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Layout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/galerie" element={<Layout><Gallery /></Layout>} />
        <Route path="/boutique" element={<Layout><Boutique /></Layout>} />
        <Route path="/commandes" element={<Layout><Orders /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/emploi" element={<Layout><Emploi /></Layout>} />
        {/* Redirect unknown routes to home */}
        <Route path="*" element={<Layout><Home /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
